/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type ResolutionOutcome =
  (typeof ResolutionOutcome)[keyof typeof ResolutionOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResolutionOutcome = {
  FIXED: "FIXED",
  WONT_FIX: "WONT_FIX",
  DUPLICATE: "DUPLICATE",
  CANNOT_REPRODUCE: "CANNOT_REPRODUCE",
  BY_DESIGN: "BY_DESIGN",
} as const;
